var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreationWizardStepWrapper',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('NeedPlyExtensionToUseAddOnHeader',_vm._g(_vm._b({},'NeedPlyExtensionToUseAddOnHeader',_vm.$props,false),_vm.$listeners))]},proxy:true}])},[_c('InstallPlyExtensionLoader',{staticClass:"width-100 height-100",on:{"extension-installed":_vm.nextStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }